import { render, staticRenderFns } from "./CreateFile.vue?vue&type=template&id=fb49e416&scoped=true&"
import script from "./CreateFile.vue?vue&type=script&lang=js&"
export * from "./CreateFile.vue?vue&type=script&lang=js&"
import style0 from "./CreateFile.vue?vue&type=style&index=0&id=fb49e416&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb49e416",
  null
  
)

export default component.exports